// extracted by mini-css-extract-plugin
export default {"title":"GcRcs","title__title":"WpDYV","title__side":"rnEzR"};